<template>
  <div>
    <el-card  style="height: 98%;">
      <el-row>
        <el-col :span="4">
          <el-select v-model="selectedStationKind" placeholder="请选择测点类型" @change="criteria.stationcode = null">
            <el-option v-for="item in stationKindList" :key="item.stationtype" :label="item.stationtypeName" :value="item.stationtype">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="criteria.stationcode" placeholder="请选择测点">
            <el-option v-for="item in stationListByType" :key="item.FYCD" :label="item.FYNM" :value="item.FYCD">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="criteria.stime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="criteria.etime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <div style="padding-left: 8px;">
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </div>
        </el-col>
        <el-col :span="4">
          <router-link :to="{path:'period-edit'}" style="float:right;">
            <el-button type="primary" icon="el-icon-plus" plain>录入</el-button>
          </router-link>
        </el-col>
      </el-row>
      <br>

      <el-table :data="pricingData" border style="width: 100%">
        <!-- <el-table-column prop="id" label="ID" width="180"></el-table-column> -->
        <el-table-column prop="stationcode" label="测点编码" width="240"></el-table-column>
        <el-table-column prop="stationname" label="测点名称"></el-table-column>
        <el-table-column prop="stime" label="开始时间" width="180">
          <template slot-scope="scope">
            {{scope.row.stime.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="etime" label="结束时间" width="180">
          <template slot-scope="scope">
            {{scope.row.etime.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="unitprice" label="单价" width="180"></el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->

            <router-link :to="{path: `period-edit?${$_stringify(scope.row)}`}">
              <el-button type="text" size="small">编辑</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <el-row>
        <el-col>
          <div style="float:right;margin:24px -10px 0 0;">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="search"
              :current-page.sync="pager.page"
              :page-size="pager.size"
              :page-count="pager.pages">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
// import StationSelector from '../components/station-selector'
import {
  stationquery,
  getallstationkind,
  getPriceingDataByPeriod
} from "@/apis/api"
import qs from 'qs'
import {PRICING_DATA_PERIOD_MODIFIED} from '../topics'

export default {
  name: 'period-search',
  data() {
    return {
      pricingData: [],
      isDirty: false,
      criteria: {
        stationcode: null,
        stime: null,
        etime: null,
      },
      pager: {
        page: 1,
        size: 12,
        // total: 0,
        pages: 1
      },

      regioncode: sessionStorage.getItem('regioncode'),
      selectedStationKind: null,
      stationKindList: [],
      stationList: [],

    }
  },
  computed: {
    stationListByType() {
      if(this.selectedStationKind) {
        return this.stationList.filter(item => item.StationType === this.selectedStationKind)
      } else {
        return this.stationList
      }
    }
  },
  watch: {
    // 查询条件改变, 重置 pager
    criteria: {
      handler() {
        this.resetPager()
      },
      deep: true
    }
  },
  activated() {
    if(this.isDirty && this.criteria.stationcode) {
      this.fetchPriceingDataByPeriod()
      this.isDirty = false
    }
  },
  created() {
    this.fetchStationList()
    this.fetchStationKindList()

    this.$bus.$on(PRICING_DATA_PERIOD_MODIFIED, () => {
      this.isDirty = true
    })
  },
  methods: {
    $_stringify(obj) {
      return qs.stringify(obj)
    },
    resetPager() {
      this.pager = {
        page: 1,
        size: 12,
        pages: 1
      }
    },
    fetchStationList() {
      stationquery({regioncode: this.regioncode,
      userid:JSON.parse(sessionStorage.getItem('userInfo')).uuid
      }).then(res => {
        this.stationList = res.result
      })
    },
    fetchStationKindList() {
      getallstationkind().then(res => {
        this.stationKindList = res.result
      })
    },
    fetchPriceingDataByPeriod() {
      getPriceingDataByPeriod({
        stationcode: this.criteria.stationcode,
        stime: this.criteria.stime,
        etime: this.criteria.etime,
        page: this.pager.page,
        size: this.pager.size
      }).then(res => {
        this.pricingData = res.result.list
        this.pager.pages = res.result.pages_count || 1

        // mock -----
        // this.pricingData = new Array(20).fill(0).map(
        //   (item, index) => ({
        //     'stationcode':'10000' + index + this.pager.page,
        //     'stationname':'测站名称' + index,
        //     'stime':'2016-09-07',
        //     'etime':'2016-09-10',
        //     'unitprice': 10 + index})
        // )
        // this.pager.pages = 3
      })
    },
    search() {
      if(!this.criteria.stationcode) {
        this.$message({
          message: '请选择测点',
          type: 'warning'
        })
        return
      }
      this.fetchPriceingDataByPeriod()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/pricing/period-search.vue